import { render, staticRenderFns } from "./PointBreakdown.vue?vue&type=template&id=e723fdfc&scoped=true&"
import script from "./PointBreakdown.vue?vue&type=script&lang=js&"
export * from "./PointBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./PointBreakdown.vue?vue&type=style&index=0&id=e723fdfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e723fdfc",
  null
  
)

export default component.exports